import { useCallback, useEffect, useState } from "react";
import { useApi } from "providers/ApiProvider";
import { SmsRule } from "~/core/resources/smsApi";
import { SmsSituation } from "~/pages/AppointmentPage/form/smsRule";

export function useSMS() {
  const { smsApi } = useApi();
  const [data, setData] = useState<SmsRule[]>([]);

  const loadData = useCallback(async () => {
    const res = await smsApi.getSmsNotifications(
      [
        SmsSituation.cancel,
        SmsSituation.reserved,
        SmsSituation.unvisited,
        SmsSituation.leave,
        SmsSituation.registered,
      ].join(",")
    );
    const payload = await res.data;

    setData(payload.data);
  }, []);

  useEffect(() => {
    loadData();
  }, []);

  return {
    smsRules: data,
    loadData: loadData,
  };
}
